import React, { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ReactDOM from "react-dom/client";
import { polyfill } from "mobile-drag-drop";
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";
import "mobile-drag-drop/default.css";
import "./index.css";
import "./table.css";
import App from "./App";
import "./ui.css";
import "./ui_cadewa.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./app/store";
import { Provider } from "react-redux";
import SuspenseContent from "./containers/SuspenseContent";
import ErrorBoundaryContent from "./containers/ErrorBoundaryContent";
import { QueryClient, QueryClientProvider } from "react-query";

import "./features/language/i18n";
import { STALE_TIME } from "./utils/globalConstantUtil";
import { ToastContainer } from "react-toastify";
import { enableTouchColumnResize } from "./utils/enableTouchColumnResize";

// タッチ端末向けに HTML5 ドラッグ&ドロップ API をポリフィルする。
// react-dnd の HTML5Backend とネイティブの draggable 実装は
// いずれも同じ HTML5 DnD イベントに依存しているため、ここで一括対応する。
polyfill({
  // iPadOS 13 以降の Safari は UA がデスクトップ表記になり、
  // ポリフィルの自動判定で「ネイティブ DnD 対応」と誤認されて
  // 起動しない。forceApply で判定をスキップし常に適用する。
  // （タッチイベントのみ扱うため PC のマウス操作には影響しない）
  forceApply: true,
  // ドラッグ中の画面自動スクロールを有効化する
  dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
});

// iOS Safari でドラッグ中のスクロールを抑止するためのワークアラウンド。
// passive でない touchmove リスナーをあらかじめ登録しておく必要がある。
window.addEventListener("touchmove", () => {}, { passive: false });

// CSS resize（マウス専用）に依存する .resizable 列をタッチでも幅変更可能にする。
enableTouchColumnResize();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      suspense: true,
      staleTime: STALE_TIME
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Router>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary fallback={<ErrorBoundaryContent />}>
        <Suspense fallback={<SuspenseContent />}>
          <Provider store={store}>
            <App />
            <ToastContainer position="bottom-right" stacked />
          </Provider>
        </Suspense>
      </ErrorBoundary>
    </QueryClientProvider>
  </Router>
  // </React.StrictMode>
);

// reportWebVitals();
